<div class="row">
  <div class="col-12 d-flex flex-column">
    <h1>Platform / Message</h1>
    <div class="message-row">
      <h3>Info</h3>
      <ui-platform-message
        [messageCode]="'Message will be placed here'"
        [type]="'info'">
      </ui-platform-message>
    </div>
    <div class="message-row">
      <h3>Success</h3>
      <ui-platform-message
        [messageCode]="'Message will be placed here'"
        [type]="'success'">
      </ui-platform-message>
    </div>
    <div class="message-row">
      <h3>Danger</h3>
      <ui-platform-message
        [messageCode]="'Message will be placed here'"
        [type]="'danger'">
      </ui-platform-message>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 d-flex flex-column">
    <h2>Types of message component</h2>
    <div class="message-row">
      <h3>Simple</h3>
      <ui-platform-message
        [messageCode]="'Message will be placed here'"
        [type]="'info'">
      </ui-platform-message>
    </div>
    <div class="message-row">
      <h3>With CTA</h3>
      <ui-platform-message
        [messageCode]="'Message will be placed here'"
        [type]="'info'">
        <ui-platform-button
          [label]="'CTA'"
          [type]="'primary'">
        </ui-platform-button>
      </ui-platform-message>
    </div>
    <div class="message-row">
      <h3>With X button</h3>
      <ui-platform-message
        [hasCloseBtn]="true"
        [messageCode]="'Message will be placed here'"
        [type]="'info'">
      </ui-platform-message>
    </div>
    <div class="message-row">
      <h3>Combination</h3>
      <ui-platform-message
        [hasCloseBtn]="true"
        [messageCode]="'Message will be placed here'"
        [type]="'info'">
        <ui-platform-button
          [label]="'CTA'"
          [type]="'primary'">
        </ui-platform-button>
      </ui-platform-message>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Code</h2>
    <p>Declare module:</p>
    <pre>{{ import }}</pre>
    <p>Use component in a template:</p>
    <pre>{{ usage }}</pre>
  </div>
</div>
